import React from 'react';
import styled, { keyframes } from 'styled-components';
import ModalCenter from '@/common/components/modal/ModalCenter';
import { LoadingIcon } from '@/common/assets/icon/icon';

interface AILoadingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinningLoader = styled.div`
  animation: ${spin} 1s linear infinite;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  gap: 16px;
`;

const TextContainer = styled.div`
  text-align: center;
  line-height: 1.5;
`;

const SubText = styled.div`
  font-size: 14px;
  color: #67727A;
  margin-top: 8px;
`;

export const AILoadingModal: React.FC<AILoadingModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <ModalCenter
      isOpen={isOpen}
      onClose={onClose}
      title="AI 분석 중..."
      maxWidth="380px"
      autoClose={false}
    >
      <ContentContainer>
        <SpinningLoader>
          <LoadingIcon size={32} />
        </SpinningLoader>
        <TextContainer>
          <div>AI가 사업자등록증을 분석하고 있습니다.</div>
          <SubText>
            잠시만 기다려주세요...
          </SubText>
        </TextContainer>
      </ContentContainer>
    </ModalCenter>
  );
}; 